// App constants and error messages

export const ERROR_MESSAGES = {
  GENERIC: 'Something went wrong. Please try again.',
  NETWORK: 'Network error. Please check your connection and try again.',
  VALIDATION: 'Please fix the errors below and try again.',
  UNAUTHORIZED: 'Invalid email or password. Please try again.',
  NOT_FOUND: 'The requested item was not found.',
  CONFLICT: 'This item already exists.',
  SERVER_ERROR: 'Server error. Please try again later.',
  INVALID_INPUT: 'Please check your input and try again.',
}

export const SUCCESS_MESSAGES = {
  SAVED: '✅ Saved successfully',
  CREATED: '✅ Created successfully',
  DELETED: '✅ Deleted successfully',
  UPDATED: '✅ Updated successfully',
  LOGGED_IN: '✅ Welcome back!',
  LOGGED_OUT: '✅ You have been logged out',
}

export const CONFIRMATION_MESSAGES = {
  DELETE_PHOTO: 'Are you sure you want to delete this photo? This cannot be undone.',
  CANCEL_BOOKING: 'Are you sure you want to cancel this booking? Guest will be refunded.',
  CLEAR_DATA: 'Are you sure you want to clear all data? This cannot be undone.',
  LOGOUT: 'Are you sure you want to log out?',
}

export const VALIDATION_LIMITS = {
  EMAIL_MAX: 100,
  PASSWORD_MIN: 6,
  NAME_MIN: 2,
  NAME_MAX: 50,
  PRICE_MAX: 99999,
  TEXT_MAX: 500,
  TEXTAREA_MAX: 1000,
  PHONE_MIN: 10,
}

export const PAGINATION = {
  BOOKINGS_PER_PAGE: 10,
  REVIEWS_PER_PAGE: 10,
  DEFAULT_PAGE: 1,
}

export const LOADING_MESSAGES = {
  SAVING: 'Saving...',
  LOADING: 'Loading...',
  UPLOADING: 'Uploading...',
  TESTING: 'Testing...',
  DELETING: 'Deleting...',
}

export const EMPTY_STATE_MESSAGES = {
  BOOKINGS: {
    title: 'No bookings yet',
    description: 'When guests book a desk, they\'ll appear here. Share your workspace to get started.',
  },
  REVIEWS: {
    title: 'No reviews yet',
    description: 'First guests will leave reviews soon.',
  },
  PHOTOS: {
    title: 'No photos',
    description: 'Listings with 5+ photos get 2x more bookings.',
  },
  BLOCKED_DATES: {
    title: 'Nothing blocked',
    description: 'Block a date for events, maintenance or holidays.',
  },
}
